<template>
  <div>
    <assign-modal/>
    <comments-modal/>
    <send-email-modal/>
    <send-whatsapp-modal/>
    <send-presentation-email-modal/>
    <send-presentation-whatsapp-modal/>
    <change-quotation-priority/>
    <choose-quotation-model-modal/>
    <approved-admin-modal/>
    <confirmation-modal
      :cancel="close"
      :confirm="callback"
      :title="confirmation[type].title"
      :message="confirmation[type].message"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import AssignModal from '_modules/quotation/components/modal/AssignModal.vue';
import CommentsModal from '_modules/quotation/components/modal/CommentsModal.vue';
import SendEmailModal from '_modules/quotation/components/modal/SendEmailModal.vue';
import QuotationActions from '_modules/quotation/components/QuotationActions';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import SendWhatsappModal from '_modules/quotation/components/modal/SendWhatsappModal.vue';
import ChangeQuotationPriority from '_modules/quotation/components/modal/ChangeQuotationPriority.vue';
import ChooseQuotationModelModal from '_modules/quotation/components/modal/ChooseQuotationModelModal.vue';
import SendPresentationEmailModal from '_modules/quotation/components/modal/SendPresentationEmailModal.vue';
import SendPresentationWhatsappModal from '_modules/quotation/components/modal/SendPresentationWhatsappModal.vue';
import ApprovedAdminModal from '_modules/quotation/components/modal/ApprovedAdminModal.vue';

import { OPTIONS_CONFIRMATION_MODAL, _OPEN_CONFIRMATION_ } from './QuotationModel';

export default {
  name: 'common-include-modals',
  mixins: [QuotationActions],
  components: {
    AssignModal,
    CommentsModal,
    SendEmailModal,
    ConfirmationModal,
    SendWhatsappModal,
    ApprovedAdminModal,
    ChangeQuotationPriority,
    ChooseQuotationModelModal,
    SendPresentationEmailModal,
    SendPresentationWhatsappModal,
  },
  data() {
    return {
      type: 'delete',
      confirmation: OPTIONS_CONFIRMATION_MODAL,
      selectedQuotation: null,
    };
  },
  methods: {
    ...mapActions(['setToggle']),
    close() {
      if (typeof this.confirmation[this.type].cancel === 'string') {
        const { cancel } = this.confirmation[this.type];
        this[cancel]();
        return;
      }

      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    callback() {
      const { callback } = this.confirmation[this.type];
      this[callback]();
    },
  },
  mounted() {
    Events.$on(_OPEN_CONFIRMATION_, ({ quotation, type }) => {
      this.selectedQuotation = quotation;
      this.type = type;
    });
  },
};
</script>
